/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import SingleTitleWithSearch from "../../components/Common/SearchableHiringCompany/SearchableHiringCompany";
import { Flex, InputNumber, notification, Progress, Select, Spin } from "antd";
import closedarkicon from "../../images/closedark.svg";
import helpCircle from "../../images/help-circle.svg";

import projectVideo from "../../images/imageWrap.png";
import Label from "../Common/Label/Label";

import { Form, Input, Button, Checkbox, Tooltip, Upload, Divider, UploadProps, Space } from "antd";
import { message } from "antd";
import MultiSkillSelector from "components/Select/MultiSkillSelector";
import { useAppDispatch } from "hooks/reduxHooks";
import { createProject } from "api/project.api";
import { useNavigate } from "react-router-dom";
import { DollerIcon, UploadIcon } from "Icon/Icon";
import { setSelectedProject } from "store/slices/searcSlice";
import EmploymentSelect from "components/Common/Employment/EmploymentSelect";
import GoogleLocationWithDropdown from "components/Common/SearchableDropdown/GoogleLocationWithDropdown";
import UploadFile from "components/Common/Input/UploadFileNew";
import { SvgIcons } from "Icon/SvgIcons";
import SearchableJobTitle from "components/Common/SearchableHiringCompany/SearchableJobTitle";
import { SaveOutlined } from "@ant-design/icons";
import CustomLabel from "components/Common/Label/CustomLabel";
import MultiSearchableJobTitle from "components/Common/SearchableHiringCompany/MultiSearchableJobTitle";
import MultiKeywordSelector from "components/Select/MultiKeywordSelector";
import InfoBanner from "./InfoBanner";
import AddCandidateCriteria from "components/HRFlow/steps/Step4Candidates/AddCandidateCriteria";

const { Option } = Select;

interface ProjectFormValues {
  projectName: string;
  hiringCompany: string;
  location: string;
  radius: number;
  employment: string;
  description: string;
  keywords: string[];
  file: File | null;
  currency: any;
}

interface CreateProjectComponentModalProps {
  onClose: () => void;
  setRefresh: React.Dispatch<React.SetStateAction<number>>;
}

const { Dragger } = Upload;

const props: UploadProps = {
  name: "file",
  multiple: true,
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  onChange(info) {
    const { status } = info.file;
    if (status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
  onDrop(e) {
    console.log("Dropped files", e.dataTransfer.files);
  },
};

// eslint-disable-next-line no-empty-pattern
const CreateProjectComponentModal: React.FC<CreateProjectComponentModalProps> = ({
  onClose,
  setRefresh
}) => {
  const navigate = useNavigate();
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
  const [fileData, setFileData] = useState<File | null>(null);

  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [progress, setProgress] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [positionData, setPositionData] = useState<string | null>(null);
  const [mustHavekeywords, setMustHavekeywords] = useState<boolean>(false);
  const [searchQuestionSetId, setSearchQuestionSetId] = useState<null | number>(null);

  const initialData = {
    projectName: "",
    hiringCompany: "",
    official_title: "",
    location: "",
    radius: 0,
    employment: "",
    description: "",
    keywords: [],
    file: null,
    currency: "USD",
  };

  const [formValues, setFormValues] = useState<ProjectFormValues>(initialData);
  const [skillsArray, setSkillsArray] = useState<string[]>([]);

  const calculateProgress = () => {
    const totalFields = Object.keys(initialData).length; // Total number of fields

    // Compare formValues with initialData to determine if fields are filled or modified
    const filledFields = Object.entries(formValues).filter(([key, value]) => {
      const initialValue = initialData[key as keyof typeof initialData];

      // Handling arrays (e.g., skills)
      if (Array.isArray(value) && Array.isArray(initialValue)) {
        return value.length > 0; // Consider as filled if the array is not empty
      }

      // Handling numbers (e.g., radius, salary)
      if (typeof value === "number" && typeof initialValue === "number") {
        return value !== initialValue; // Consider as filled if the number is different from the initial
      }

      // Handling strings (e.g., projectName, hiringCompany, etc.)
      if (typeof value === "string" && typeof initialValue === "string") {
        return value.trim() !== initialValue; // Consider as filled if the string is not empty and differs from initial
      }

      // Handling null or object (e.g., file)
      return value && value !== initialValue; // General check for other types like null or objects
    }).length;

    const progressPercentage = (filledFields / totalFields) * 100; // Calculate progress percentage
    setProgress(Math.ceil(progressPercentage)); // Update progress state
  };

  const handleMustHaveChange = () => {
    setMustHavekeywords(!mustHavekeywords); // Dispatch action to update Redux store
  };

  const handleFormSubmit = async (formValues: any) => {
    if (formValues.minimum_salary != null && formValues.maximum_salary != null) {
      if (formValues.minimum_salary >= formValues.maximum_salary) {
        form.setFields([
          {
            name: "maximum_salary",
            errors: ["Maximum salary must be greater than minimum salary."],
          },
        ]);
        return;
      }
    }
    setLoading(true);

    if (formValues.minimum_salary === undefined) {
      formValues.minimum_salary = "";
    }
    if (formValues.maximum_salary === undefined) {
      formValues.maximum_salary = "";
    }

    const formData = new FormData();
    formData.append("title", formValues.projectName);
    if (searchQuestionSetId) {
      formData.append("selected_question_set", searchQuestionSetId.toString());
    }
    formData.append("recruiting_company", formValues.hiringCompany);
    formData.append("locations", formValues.location ? JSON.stringify(formValues.location) : JSON.stringify([]));
    formData.append("official_title", formValues.official_title);
    formData.append("radius", formValues.radius ? formValues.radius?.toString() : "");
    formData.append("minimum_salary", formValues.minimum_salary?.toString());
    formData.append("maximum_salary", formValues.maximum_salary?.toString());
    formData.append("job_type", formValues.employment ? formValues.employment : "");
    formData.append("description", formValues.description ? formValues.description : "");
    formData.append(
      "keywords",
      formValues.keywords ? JSON.stringify(formValues.keywords) : JSON.stringify([])
    ); // Keywords can be stringified as JSON
    formData.append("currency", formValues.currency || "USD");

    // if (formValues.file) {
    //   formData.append("job_description", formValues.file);
    // }

    if (mustHavekeywords) {
      formData.append("must_have_keywords", formValues.keywords ? JSON.stringify(formValues.keywords) : JSON.stringify([]));
    }

    if (fileData) {
      formData.append("job_description", fileData);
    }

    try {
      const response = await createProject(formData);

      dispatch(setSelectedProject(response));
      //   navigate("/search-for-project");
      notification.success({
        message: "Success",
        description: "Project created successfully",
      });
      onClose();
      setRefresh((refresh) => refresh + 1);
      setLoading(false);

      // Optionally, reset form or provide feedback to user

      // onCancel();
    } catch (error) {
      notification.error({
        message: "Failed",
        description: "Failed to create project!",
      });
      setLoading(false);

      // Handle the error, show error message to user, etc.
    }
  };

  const selectAfter = (
    <Form.Item name="currency" style={{ marginBottom: 0 }}>
      <Select defaultValue="USD" style={{ width: 60 }}>
        <Option value="USD">$</Option>
        <Option value="EUR">€</Option>
        <Option value="GBP">£</Option>
      </Select>
    </Form.Item>
  );
  const handleSkillChange = (keywords: any) => {
    setFormValues({ ...formValues, keywords });
    setSkillsArray((prevSkills) => [...prevSkills, keywords.value]);
  };

  const handleCityChange = (selected: string[] | string) => {
    const lastSelectedValue = Array.isArray(selected) ? selected[selected.length - 1] : selected;
    setSelectedLocation(lastSelectedValue);
    form.setFieldsValue({ location: lastSelectedValue });
  };

  const handleHighringCompany = (company: string) => {
    form.setFieldsValue({ hiringCompany: company });
  };

  useEffect(() => {
    calculateProgress();
  }, [formValues]);

  return (
    <div className="create-project-wrapper bg-Filter-bg border-r border-main-border overflow-auto">

      <InfoBanner
        title="Create a Project"
        description="Create a project by entering the required information below."
      />

      <div className="bg-white p-0">
        {/* <div className="mx-2 rounded-md bg-bg-secondary flex gap-4 p-4 mb-10">
          <div className="p-3 flex gap-5">
            <div className="image-wrapper relative flex-initial w-7/12">
              <img src={projectVideo} alt="Project Video" />
            </div>
            <div className="flex flex-col gap-3">
              <div className="flex gap-3">
                <img src={helpCircle} alt="Question Icon" />
                <h4 className="font-bold text-fonttext-primary text-base w-6/12">
                  How to create your first project
                </h4>
              </div>
              <p className="font-normal text-text-tertiary text-sm">
                Id non egestas ultrices adipiscing posuere ultrices vitae. Aliquam vestibulum
                consectetur{" "}
              </p>
            </div>
            <div className="col-span-2 border-t-2 bg-[#dde0e5] h-full w-px mx-2"></div>
          </div>
          <div className="p-3 flex flex-col gap-3">
            <h4 className="font-bold text-fonttext-primary text-base">
              How to create your first project
            </h4>
            <div className="w-full flex gap-4">
              <Progress percent={progress} status="active" showInfo={true} />
            </div>

            <p className="font-normal text-text-tertiary text-sm">
              Id non egestas ultrices adipiscing posuere ultrices vitae. Aliquam vestibulum
              consectetur{" "}
            </p>
          </div>
          <div className="space-y-3 text-xs font-medium text-text-tertiary p-4 pt-3">
            <button className="p-2 rounded-md w-8 h-8 hover:bg-white">
              <img src={closedarkicon} alt="Close" />
            </button>
          </div>
        </div> */}

        <Form
          form={form}
          layout="vertical"
          onFinish={handleFormSubmit}
          className="grid grid-cols-1 md:grid-cols-2 h-full overflow-auto"
          onValuesChange={(changedValues, allValues) => setFormValues(allValues)}
        >
          {/* Left Column */}
          <div className="space-y-3 text-xs  text-text-tertiary pt-6 pl-2 pr-6">
            <Form.Item
              name="projectName"
              rules={[{ required: true, message: "Please enter the project name" }]}
              className="mb-5"
            >
              <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                <Label labelTitle="Project Name" isHelpIconRequired={false} isRequired={true} />
                <Input
                  placeholder="Enter Name"
                  rootClassName="py-2 px-3"
                  className="rounded-lg "
                  size="large"
                />
              </Space>
            </Form.Item>
            <Form.Item
              style={{ width: "100%" }}
              name="official_title"
              rules={[{ required: true, message: "Please enter the position title." }]}
              className="mb-5"
            >
              <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                <CustomLabel
                  labelTitle="Position"
                  isHelpIconRequired={true}
                  isRequired={true}
                  tooltipText="The specific job title you will be sourcing for."
                />
                {/* <SearchableJobTitle
                  placeholder="Position"
                  onChange={(title: any) => {
                    form.setFieldValue("official_title", title);
                  }}
                ></SearchableJobTitle> */}
                <MultiSearchableJobTitle
                  placeholder="Position"
                  defaultValue={positionData}
                  setPositionData={setPositionData}
                  positionData={positionData}
                  onChange={(value: any) => {
                    console.log("Value 300: ", value);
                    if (value !== undefined && value !== null) {
                      if (Array.isArray(value)) {
                        setPositionData(value.length > 0 ? value[value.length - 1].value : null);
                        form.setFieldsValue({ official_title: value.length > 0 ? value[value.length - 1].value : null });
                      } else {
                        setPositionData(value.value);
                        form.setFieldsValue({ official_title: value.value });
                      }
                    } else {
                      form.setFieldsValue({ official_title: null });
                      setPositionData(null);
                    }

                  }}
                // onChange={(value: any) => {
                //   form.setFieldsValue({ official_title: value.value });
                // }}
                ></MultiSearchableJobTitle>
              </Space>
            </Form.Item>
            <Form.Item
              name="hiringCompany"
              rules={[{ required: true, message: "Please select a hiring company" }]}
              className="mb-5"
            >
              <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                <Label
                  labelTitle="Hiring Company"
                  isHelpIconRequired={true}
                  isRequired={true}
                  tooltipText="Hiring Company"
                />
                <SingleTitleWithSearch
                  placeholder="Start Typing"
                  onChange={(value: string) => {
                    handleHighringCompany(value);
                  }}
                />
              </Space>
            </Form.Item>
            <div className="flex p-0">
              {" "}
              <Form.Item
                name="location"
                // rules={[{ required: true, message: "Please select a location" }]}
                className="w-3/4 m-0 mr-4"
              >
                <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                  <Label labelTitle="Location" isHelpIconRequired={false} isRequired={false} />
                  <GoogleLocationWithDropdown
                    handleChange={handleCityChange}
                    selectedLocations={selectedLocation}
                    placeholder={"Search for a location..."}
                    isBorder={false}
                  />
                </Space>
              </Form.Item>
              <Form.Item name="radius" className="w-1/4 m-0">
                <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                  <Label labelTitle="Radius (ml)" isHelpIconRequired={false} isRequired={false} />
                  <Input
                    type="number"
                    placeholder="0"
                    rootClassName="py-2 px-3"
                    className="rounded-lg"
                  />
                </Space>
              </Form.Item>
            </div>

            <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
              <Label labelTitle="Salary" isHelpIconRequired={false} isRequired={false} />
              <Flex gap={10} className="w-full">
                <Form.Item
                  name="minimum_salary"
                  rules={[{ required: false, message: "Please enter the minimum salary" }]}
                  style={{ flex: 1 }}
                >
                  <InputNumber
                    size="large"
                    addonAfter={selectAfter}
                    placeholder="Min salary"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item
                  name="maximum_salary"
                  rules={[{ required: false, message: "Please enter the maximum salary" }]}
                  style={{ flex: 1 }}
                >
                  <InputNumber
                    size="large"
                    addonAfter={selectAfter}
                    placeholder="Max salary"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Flex>
            </Space>

            <Form.Item
              name="employment"
              // rules={[{ required: true, message: "Please select employment type" }]}
              className="mb-5"
            >
              <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                <Label labelTitle="Employment" isHelpIconRequired={false} isRequired={false} />
                <EmploymentSelect
                  onChange={(value) => {
                    form.setFieldsValue({ employment: value });
                  }}
                ></EmploymentSelect>
              </Space>
            </Form.Item>
          </div>

          {/* Right Column */}
          <div className="space-y-3 text-xs  text-text-tertiary pt-6 pl-6 pr-2">
            <Form.Item
              name="keywords"
              rules={[{ required: false, message: "Please select keywords" }]}
            >
              <Space direction="vertical" size="small" className="w-full gap-[6px]">
                <CustomLabel
                  labelTitle="Keywords"
                  isHelpIconRequired={true}
                  isRequired={false}
                  tooltipText="Keywords"
                />
                <MultiKeywordSelector
                  placeholder="eg: React.js"
                  skills={form.getFieldValue("keywords") || []} // Ensure `skills` is an array
                  rootClassName={
                    (form.getFieldValue("keywords")?.length || 0) > 0 ? "border-primary" : ""
                  }
                  handleDeselect={(deselectedSkill: string) => {
                    const currentSkills = form.getFieldValue("keywords") || [];
                    form.setFieldsValue({
                      keywords: currentSkills.filter((skill: string) => skill !== deselectedSkill),
                    });
                  }}
                  onChange={(selectedSkills: any) => {
                    const skillLabels = selectedSkills.map((skill: any) => skill?.value);
                    form.setFieldsValue({ keywords: skillLabels });
                  }}
                />
              </Space>
            </Form.Item>
            <p className="ant-upload-text" style={{ marginTop: "-5%", color: "darkgray" }}>
              <Checkbox name="must_have_keywords" onChange={handleMustHaveChange} checked={mustHavekeywords}>Must Have</Checkbox>
            </p>
            <Form.Item
              name="description"
              // rules={[{ required: true, message: "Please enter a description" }]}
              className="mb-5"
            >
              <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                <Label
                  labelTitle="Additional information"
                  isHelpIconRequired={false}
                  isRequired={false}
                />
                <Input.TextArea
                  placeholder="Enter a Description..."
                  rootClassName="py-2 px-3"
                  className="rounded-lg"
                  rows={8}
                />
              </Space>
            </Form.Item>

            <Form.Item
              name="file"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                console.log("Event:", e); // Debugging
                return e?.fileList || [];
              }} // Store fileList
              className="mb-5"
            >
              <Space direction="vertical" size={"small"} className="w-full gap-[6px]">
                <CustomLabel
                  labelTitle="Upload reference materials"
                  isHelpIconRequired={true}
                  isRequired={false}
                  tooltipText={
                    "This is where you can upload documents you can refer to and use later.\nDocument examples include job descriptions, research documents, interview questions, etc."
                  }
                />
                <UploadFile {...props} secText="PDF and Docx files supported" setFileData={setFileData} />
              </Space>
            </Form.Item>
          </div>
          <div className="border p-4 h-full mt-4 w-full col-span-4 flex-grow">
            <AddCandidateCriteria
              search_question_set_id={searchQuestionSetId}
              setSearchQuestionSetId={setSearchQuestionSetId}
            />
          </div>
          {/* Divider */}
          {/* <Divider className="col-span-2" /> */}

          {/* Footer */}
          <div className="col-span-2 flex font-medium items-center justify-between text-sm my-4 px-6">
            {/* <Form.Item name="createTalentPool" valuePropName="checked" noStyle>
              <Checkbox>Create Talent Pool of this Project</Checkbox>
            </Form.Item> */}
            <div
              className="flex space-x-2 justify-end ml-auto"
              style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}
            >
              <Button
                //type="primary" 
                htmlType="submit"
                className="text-white py-1 px-3 rounded-md bg-[#845dda] border border-[#7F56D9]"
              >
                {loading ? (
                  <Spin spinning={loading} size="small" className="custom-spin" />
                ) : (
                  <SaveOutlined />
                )}
                Save Project
              </Button>
            </div>
            {/* <div className="flex space-x-2 justify-end ml-auto">
              <Button
                size="small"
                type="primary"
                htmlType="submit"
                className="bg-primary text-white py-1 px-3 rounded-md text-base  h-11 hover:bg-[#7F56D9]"
              >
                Save and Proceed
              </Button>
            </div> */}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CreateProjectComponentModal;
